"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStandaloneBrand = isStandaloneBrand;
/**
 * A standalone brand uses Framework as software, paying for its own plan,
 * rather than being a brand an agency (NewForm) manages. The parent link is
 * what decides it: a managed brand sits under its agency, a standalone one
 * has no parent. Agencies have no parent either, so they are excluded.
 *
 * The type alone is not reliable: self-serve customers such as Kovo Credit
 * are typed CLIENT_BRAND, not INDEPENDENT_BRAND, so a parentless brand of
 * either type counts.
 *
 * Takes the two fields rather than a Prisma row so the frontend can call it
 * without importing the database package.
 */
function isStandaloneBrand(organization) {
    return organization.type !== "AGENCY" && !organization.parentOrganizationId;
}
